import { Typography } from '@portals/core/src/components/Typography/Typography';
import React from 'react';

import {
  InternHeadline,
  InternIcon,
  LinkActionLink,
  LinkAssetLink,
  LinkExternalLink,
  LinkInternalLink,
  LinkThematischerLink,
} from '../../../../models';
import { useLinkProps } from '../../../hooks/useLinkProps';
import { LegalFooterServiceLink } from '../LegalFooterServiceLink/LegalFooterServiceLink';

interface Props {
  node: {
    __component: 'intern.icon-link';
    id: string;
    link?: (LinkInternalLink | LinkExternalLink | LinkThematischerLink | LinkActionLink | LinkAssetLink)[];
    icon?: InternIcon;
    headline?: InternHeadline;
    text?: string;
  };
}

export const LegalFooterLink: React.FunctionComponent<Props> = ({ node }: Props) => {
  const { linkProps, anchorProps } = useLinkProps(node.link && node.link[0]);

  return (
    <LegalFooterServiceLink {...linkProps} key={node.id}>
      <Typography variant="button" {...anchorProps}>
        {node.link && node.link[0]?.text}
      </Typography>
    </LegalFooterServiceLink>
  );
};
